import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-purpl-table-button',
  templateUrl: './purpl-table-button.component.html',
  styleUrls: ['./purpl-table-button.component.scss'],
})
export class PurplTableButtonComponent implements OnInit {
  @Output() onPress: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}
}
